export interface EmailSettingsState {
    email: string,
}

export enum GenericApiErrors{
    Failed
}

export interface LoginPayload {
    codeResponse: string,
}
